<template>
  <div>
    edit message
    <v-text-field v-model="localValue.message" />
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
</script>